import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Text from 'components/base/Text';
import withSetting from './SettingsHOC';
import { Flex } from 'components/base/layout-components';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { TextareaAutosize } from '@material-ui/core';

const TextareaAutosizeWrapper = styled(TextareaAutosize)`
  resize: none;
  border-color: ${getColor('botticelli')};
  font-size: 15px;
  line-height: 25px;
`;

const TextArea = props => {
  const handleTextChange = ({ target }) => {
    props.onChange({
      target: { name: target.name, value: target.value.split('\n') }
    });
  };

  return (
    <TextareaAutosizeWrapper
      onChange={handleTextChange}
      value={props.value ? props.value.join('\n') : ''}
      name={props.name}
    />
  );
};

const getInputField = (fieldOption, handleValueChange, value) => {
  const name = fieldOption.key_name;
  if (fieldOption.input === 'isArray') {
    return (
      <TextArea
        name={name}
        onChange={handleValueChange}
        value={value || []}
        placeholder={fieldOption.hint}
      />
    );
  }
  if (fieldOption.input === 'isString') {
    return (
      <TextField
        name={name}
        inputProps={{ style: { fontSize: 15 } }}
        variant='outlined'
        onChange={handleValueChange}
        value={value || ''}
      />
    );
  }
};

const createFieldOption = (fieldOption, handleValueChange, value = null) => {
  const isInput = fieldOption.input;

  return (
    <Flex key={fieldOption.key_name} direction='column' pb='small'>
      <Text
        lineHeight={1.7}
        size='large'
        color='darkGray'
        weight='bold'
        dangerouslySetInnerHTML={{ __html: fieldOption.label }}
      />
      <Text
        lineHeight={1.7}
        size='large'
        color='darkGray'
        dangerouslySetInnerHTML={{ __html: fieldOption.subtext }}
      />
      {isInput && getInputField(fieldOption, handleValueChange, value)}
    </Flex>
  );
};

const CustomJsonArea = props => {
  const {
    onChange,
    value,
    customOptions,
    wasReset,
    setWasReset,
    dataCy = ''
  } = props;

  const [jsonStates, setJsonStates] = useState(
    Object.assign(
      {},
      ...value.map(val => {
        return { [val.key]: val.regex_pattern };
      })
    )
  );

  useEffect(() => {
    if (wasReset) {
      setJsonStates({ [value.key]: value.regex_pattern });
      setWasReset(false);
    }
  }, []);

  const handleValueChange = e => {
    const { name, value: targetValue } = e.target;

    setJsonStates({
      ...jsonStates,
      [name]: targetValue
    });

    const newValue = _.clone(value);
    newValue[newValue.findIndex(val => val.key === name)] = {
      key: name,
      regex_pattern: targetValue
    };

    onChange(newValue);
  };

  return (
    <Flex direction='column' justify='space-between' data-cy={dataCy}>
      {_.map(customOptions.options, customOption =>
        createFieldOption(
          customOption,
          handleValueChange,
          jsonStates[customOption.key_name]
        )
      )}
    </Flex>
  );
};

export default withSetting(CustomJsonArea);
